<template>
  <div class="container detailPage padding15">
    <van-nav-bar
      title="积分详情"
      left-text
      fixed
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="topImg">
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(image, index) in info.imgUrlArr" :key="index">
          <van-image fit="cover" :src="image" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <van-row type="flex" justify="space-between" class="marginTop10 colorGrey1">
      <van-col span="24" class="name">{{ info.name }}</van-col>
    </van-row>

    <van-row type="flex" justify="space-between" class="marginTop15 points">
      <van-col span="24" class="van-ellipsis"
        ><i class="iconfont icon-jifen marginRight5" style="color: #ccc" /><span
          class="num fz16"
          >{{ info.integral }}分</span
        ></van-col
      >
    </van-row>
    <div class="concact">
      <div>{{ info.comDescribe }}</div>
    </div>
    <van-tabs v-model="tabActive" scrollspy>
      <van-tab title="图文详情">
        <div class="ql-snow ql-editor">
          <div class="activity-main" v-html="info.details"></div>
        </div>
      </van-tab>
    </van-tabs>

    <div class="fixedBtnGroup">
      <van-goods-action>
        <van-goods-action-button
          color="#D6253C"
          type="warning"
          text="马上兑换"
          @click="handleBuy"
        />
      </van-goods-action>
    </div>
    <van-dialog v-model="dialogVisible" title="标题" show-cancel-button>
      <img src="https://img01.yzcdn.cn/vant/apple-3.jpg" />
    </van-dialog>
  </div>
</template>

<script>
import { goodsDetail, goodsExchange } from "@/api/data";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  data() {
    return {
      isCollected: false,
      info: "",
      tabActive: 0,
      dialogVisible:false
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getInfo() {
      let _this = this;
      goodsDetail({ id: this.$route.query.id }).then((res) => {
        if (res) {
          _this.info = res.data;
          let imgUrlArr = [];

          if (res.data.imgUrl) {
            imgUrlArr = res.data.imgUrl.split(",");
          }
          if (res.data.mainImgUrl) {
            imgUrlArr.unshift(res.data.mainImgUrl);
          }
          _this.info.imgUrlArr = imgUrlArr;
          document.title = _this.info.name;
        }
      });
    },
    handleBuy() {
      let _this = this;
      // _this.dialogVisible = true
      this.$dialog
        .confirm({
          title: "兑换",
          message: "确定使用积分兑换此商品吗？",
        })
        .then(() => {
          goodsExchange({
            commodityId: this.$route.query.id,
          }).then((res) => {
            if (res) {
              this.$router.push({
                path: "/exchangeGoodsSuccess",
                query: {
                  isSuccess: 1,
                },
              });
            } else {
              this.$router.push({
                path: "/exchangeGoodsSuccess",
                query: {
                  isSuccess: 2,
                },
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang='less'>
.detailPage {
  .name {
    // min-height: 50px;
  }
}
</style>